import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  standalone: true,
})
export class LogoComponent {
  @Input() width!: string;
  @Input() height!: string;
}
